"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaUrlProperty = exports.ctaUrlPropertyDefinition = void 0;
exports.ctaUrlPropertyDefinition = {
    view: { label: 'CTA url' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'cta-action-type',
                'cta-button-label',
                'cta-url-link',
                'cta-start-date',
                'cta-end-date',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'cta-url',
};
const isCtaUrlProperty = (prop) => {
    return prop.name === exports.ctaUrlPropertyDefinition.name;
};
exports.isCtaUrlProperty = isCtaUrlProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLXVybC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2N0YS11cmwucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSx3QkFBd0IsR0FBRztJQUN0QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsU0FBUyxFQUFFO0lBQzFCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUU7Z0JBQ1IsaUJBQWlCO2dCQUNqQixrQkFBa0I7Z0JBQ2xCLGNBQWM7Z0JBQ2QsZ0JBQWdCO2dCQUNoQixjQUFjO2FBQ2Y7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxTQUFTO0NBQ2dCLENBQUE7QUFJMUIsTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLElBQWtCLEVBQTBCLEVBQUU7SUFDN0UsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGdDQUF3QixDQUFDLElBQUksQ0FBQTtBQUNwRCxDQUFDLENBQUE7QUFGWSxRQUFBLGdCQUFnQixvQkFFNUIifQ==